(function (module) {
    "use strict";

    module.component('switchButton', {
        template: require('./switchButton.html'),
        bindings: {
            switchOperator: "=",
            firstButtonTitle: "@",
            secondButtonTitle: "@"
        },
        controller: ['$scope', function(this: $TSFixMe, $scope: $TSFixMe) {
            var $ctrl = this;
            $ctrl.$onInit = () =>{

            }
        }]
    })

})(angular.module('topline.modules'));
